import React, { useState } from "react";
import { HeaderVariant } from "ui/blocks/HeaderVariant/HeaderVariant";
import ScrollToTop from "../ui/base/ScrollToTop/ScrollToTop";
import { Accordion } from "../ui/blocks/Accordion";
import { Footer } from "../ui/blocks/Footer";
import { Search } from "../ui/blocks/Search";

const FaqPage = () => {
  const [searchData, setSearchData] = useState([]);
  const handleSearch = (val) => setSearchData(val.split(" "));

  return (
    <ScrollToTop>
      <HeaderVariant />
      <Search onSearchSubmit={(val) => handleSearch(val)} />
      <Accordion filterBySearch={searchData} />
      <Footer />
    </ScrollToTop>
  );
};

export default FaqPage;
